import FormModal from '@insurancemenu/imenu-components-lib/dist/components/modals/FormModal';
import React, { useEffect, useState } from 'react';
import { FileUpload } from '@insurancemenu/imenu-components-lib';
import { UPLOAD_FILE_TYPES } from '@insurancemenu/imenu-components-lib/dist/components/FileUpload';
import { observer } from 'mobx-react-lite';
import { ModalType } from '@insurancemenu/imenu-components-lib/dist/helpers/ModalsHelper';
import { UploadDocumentModalStore } from 'store/modules/upload-documents/ui-stores/uploadDocumentModalStore';
import {
  FirstRowStyled,
  FormBodyWrapperStyled,
  InputTextStyled,
  SectionCaptionStyled,
  SectionHeadingStyled,
  SelectStyled,
} from './styles';
import {
  UPLOAD_DOCUMENT_NAME_TEST_ID,
  UPLOAD_DOCUMENT_TYPE_TEST_ID,
  UPLOAD_DOCUMENT_FILE_UPLOAD_TEST_ID,
  UPLOAD_DOCUMENT_MODAL_TEST_ID,
} from '../constants';

interface Props {
  show: boolean;
  onClose: () => void;
  modalStore: UploadDocumentModalStore;
}

const UploadDocumentModal: React.FC<Props> = observer(({ show, onClose, modalStore }) => {
  const {
    availableDocOptions,
    currentUploadStrategy,
    isLoading,
    isDataValid,
    setFile,
    form,
    resetModal,
    requestUploadDocument,
  } = modalStore;

  const [resetUiFile, setResetUiFile] = useState(false);

  useEffect(() => {
    setResetUiFile(false);
  }, [show]);

  const onSubmit = async (): Promise<void> => {
    onClose();
    await requestUploadDocument();
    setResetUiFile(true);
    resetModal();
  };

  function handleClose(): void {
    setResetUiFile(true);
    resetModal();
    onClose();
  }

  return (
    <FormModal
      show={show}
      onClose={handleClose}
      title="Upload Document"
      modalType={ModalType.CREATION}
      loading={isLoading}
      formContent={
        <FormBodyWrapperStyled>
          <FirstRowStyled>
            <SelectStyled
              label="Document Type"
              options={availableDocOptions}
              name="docType"
              onChange={form.onFieldChange}
              value={form.fields.docType.value}
              validationPassed={!form.fields.docType.unpassedValidationMsg}
              validationMessage={form.fields.docType.unpassedValidationMsg}
              required
              data-test-id={UPLOAD_DOCUMENT_TYPE_TEST_ID}
            />
            {currentUploadStrategy === 'CUSTOM_DOC' && (
              <InputTextStyled
                label="Document Name"
                placeholder="Custom Document"
                name="docName"
                value={form.fields.docName.value}
                onChange={form.onFieldChange}
                validationPassed={!form.fields.docName.unpassedValidationMsg}
                validationMessage={form.fields.docName.unpassedValidationMsg}
                data-test-id={UPLOAD_DOCUMENT_NAME_TEST_ID}
              />
            )}
          </FirstRowStyled>
          <SectionHeadingStyled>Import Document</SectionHeadingStyled>
          <SectionCaptionStyled>The file will be associated with the information specified above.</SectionCaptionStyled>
          <FileUpload
            onChange={setFile}
            fileMimeTypes={[
              UPLOAD_FILE_TYPES.xls,
              UPLOAD_FILE_TYPES.xlsx,
              UPLOAD_FILE_TYPES.docx,
              UPLOAD_FILE_TYPES.tsv,
              UPLOAD_FILE_TYPES.pdf,
            ]}
            allowMultipleFiles={false}
            shouldBeReset={resetUiFile}
            data-test-id={UPLOAD_DOCUMENT_FILE_UPLOAD_TEST_ID}
          />
        </FormBodyWrapperStyled>
      }
      closeButtonText="Cancel"
      submitButtonText="Add"
      isFormValid={isDataValid}
      onSubmit={onSubmit}
      data-test-id={UPLOAD_DOCUMENT_MODAL_TEST_ID}
    />
  );
});

export default UploadDocumentModal;
